import Actions                  from 'Redux/Actions';
import { ofType }               from 'redux-observable';
import { from }                 from 'rxjs';
import { mergeMap, catchError } from 'rxjs/operators';
import { TEpic }                from 'Redux/Config';
import { EventRepository }      from 'Domain/Repositories';
import { message }              from 'antd';

export const deleteEventEpic: TEpic = (action$) => {
  return action$.pipe(
    ofType(Actions.deleteEventRequest.type),
    mergeMap(action => from(EventRepository.remove(action.payload.id))
      .pipe(
        mergeMap(() => {
          message.success('Event wurde erfolgreich gelöscht.');
          return from([
            Actions.deleteEventSuccess({ id: action.payload.id }),
          ]);
        }),
        catchError(error => {
          return from([
            Actions.deleteEventFailure(error),
          ]);
        })
      )
    ),
  );
};
